export enum ClinicalTaskDue {
  Date = "date",
  Consult = "consult"
}
